<template>
<div class="chapter">
<div class="inner_page">
<h2 class="nobreak1" id="calibre_toc_8">CHAPTER TWO</h2>
<p class="noindent">Scripps O’Neil stood outside the Mancelona High
School looking up at the lighted windows. It was dark
and the snow was falling. It had been falling ever since
Scripps could remember. A passer-by stopped and stared
at Scripps. After all, what was this man to him? He
went on.</p>
<p class="calibre1">Scripps stood in the snow and stared up at the lighted
windows of the High School. Inside there people were
learning things. Far into the night they worked, the boys
vying with the girls in their search for knowledge, this
urge for the learning of things that was sweeping America.
His girl, little Lousy, a girl that had cost him a cool
seventy-five dollars in doctors’ bills, was in there learning.
Scripps was proud. It was too late for him to learn,
but there, day after day and night after night, Lousy was
learning. She had the stuff in her, that girl.</p>
<p class="calibre1">Scripps went on up to his house. It was not a big house,
but it wasn’t size that mattered to Scripps’s old woman.</p>
<p class="calibre1">“Scripps,” she often said when they were drinking together,
“I don’t want a palace. All I want is a place to
keep the wind out.” Scripps had taken her at her word.
Now, as he walked in the late evening through the snow
and saw the lights of his own home, he felt glad that he
had taken her at her word. It was better this way than if
he were coming home to a palace. He, Scripps, was not
the sort of chap that wanted a palace.</p>
<p class="calibre1">He opened the door of his house and went in. Something
kept going through his head. He tried to get it out,
but it was no good. What was it that poet chap his friend
Harry Parker had met once in Detroit had written?
Harry used to recite it: “Through pleasures and palaces
though I may roam. When you something something
something there’s no place like home.” He could not remember
the words. Not all of them. He had written a
simple tune to it and taught Lucy to sing it. That was
when they first were married. Scripps might have been a
composer, one of these chaps that write the stuff the Chicago
Symphony Orchestra plays, if he had had a chance
to go on. He would get Lucy to sing that song tonight.
He would never drink again. Drinking robbed him of his
ear for music. Times when he was drunk the sound of the
whistles of the trains at night pulling up the Boyne Falls
grade seemed more lovely than anything this chap Stravinsky
had ever written. Drinking had done that. It was
wrong. He would get away to Paris. Like this chap Albert
Spalding that played the violin.</p>
<p class="calibre1">Scripps opened the door. He went in. “Lucy,” he
called, “it is I, Scripps.” He would never drink again. No
more nights out on the railroad. Perhaps Lucy needed a
new fur coat. Perhaps, after all, she had wanted a palace
instead of this place. You never knew how you were
treating a woman. Perhaps, after all, this place was not
keeping out the wind. Fantastic. He lit a match. “Lucy!”
he called, and there was a note of dumb terror in his
mouth. His friend Walt Simmons had heard just such a
cry from a stallion that had once been run over by a passing
autobus in the Place Vendôme in Paris. In Paris
there were no geldings. All the horses were stallions.
They did not breed mares. Not since the war. The war
changed all that.</p>
<p class="calibre1">“Lucy!” he called, and again “Lucy!” There was no
answer. The house was empty. Through the snow-filled
air, as he stood there alone in his tall leanness, in his own
deserted house, there came to Scripps’s ears the distant
sound of an Indian war-whoop.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap2.vue?25d9d57c